import React from 'react'
import Navbar from '../../Shared/Navbar'
import './AptitudeLanding.css'

function AptitudeLanding() {
  // More dummy data for demonstration
  const upcomingTests = [
    { title: "Aptitude Test May 2025", date: "2025-05-24", description: "Test on Quantitative Aptitude and Logical Reasoning." },
    { title: "Aptitude Test May 2025", date: "2025-05-31", description: "Focus on Analytical Reasoning and Data Sufficiency." }
  ];
  const pastTests = [
    { title: "Aptitude Test May 2024", date: "2024-05-10", description: "Covered Data Interpretation and Verbal Ability." },
    { title: "Aptitude Test April 2024", date: "2024-04-12", description: "Questions on Arithmetic and Logical Puzzles." },
    { title: "Aptitude Test March 2024", date: "2024-03-08", description: "Tested Number Series and Coding-Decoding." }
  ];
  const sampleQuestions = [
    { question: "What is the next number in the sequence: 2, 4, 8, 16, ?", topic: "Number Series" },
    { question: "If A is taller than B and B is taller than C, who is the tallest?", topic: "Logical Reasoning" },
    { question: "A train 150 m long is running at 60 km/hr. In what time will it pass a pole?", topic: "Time & Distance" },
    { question: "Find the odd one out: 3, 5, 11, 14, 17, 21", topic: "Odd One Out" },
    { question: "If the code for CAT is DBU, what is the code for DOG?", topic: "Coding-Decoding" }
  ];

  // Helper to get day of week from date string
  const getDayOfWeek = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString(undefined, { weekday: 'long' });
  };

  return (
    <>
      <Navbar />
      <div className="aptitude-landing-container">
        {/* Upcoming Test(s) at the top, locked */}
        {upcomingTests.length > 0 && (
          <section className="upcoming-tests-top">
            <h2>Upcoming Aptitude Test</h2>
            <ul>
              {upcomingTests.map((test, idx) => (
                <li key={idx} className="test-card upcoming locked">
                  <span className="test-lock-icon" title="Locked">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <rect x="4" y="9" width="12" height="7" rx="2" fill="#b0b8c9"/>
                      <path d="M7 9V7a3 3 0 1 1 6 0v2" stroke="#b0b8c9" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                  </span>
                  <div className="test-title">{test.title}</div>
                  <div className="test-date coming-date">
                    Coming on {test.date} ({getDayOfWeek(test.date)})
                  </div>
                  <div className="test-desc">{test.description}</div>
                </li>
              ))}
            </ul>
          </section>
        )}

        <section className="aptitude-hero">
          <h1>Aptitude Test</h1>
          <p>
            Welcome! Here you can find details about upcoming and past aptitude tests, and practice with sample questions to sharpen your skills.
          </p>
        </section>

        {/* Past Tests, unlocked */}
        <section className="aptitude-announcement-board">
          <h2>Past Aptitude Tests</h2>
          <ul>
            {pastTests.map((test, idx) => (
              <li key={idx} className="test-card past unlocked">
                <span className="test-unlock-icon" title="Unlocked">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <rect x="4" y="9" width="12" height="7" rx="2" fill="#8bc34a"/>
                    <path d="M13 9V7a3 3 0 1 0-6 0" stroke="#8bc34a" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </span>
                <div className="test-title">{test.title}</div>
                <div className="test-date">{test.date}</div>
                <div className="test-desc">{test.description}</div>
              </li>
            ))}
          </ul>
        </section>

        <section className="aptitude-questions-showcase">
          <h2>Sample Aptitude Questions</h2>
          <div className="questions-list">
            {sampleQuestions.map((q, idx) => (
              <div key={idx} className="question-card">
                <div className="question-text">{q.question}</div>
                <div className="question-topic">{q.topic}</div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </>
  )
}

export default AptitudeLanding